var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgVisibility = function SvgVisibility(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9539_35731)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 5.5C8.42 5.5 2.5 9.5 2.5 12C2.5 14.5 8.42 18.5 12 18.5C15.58 18.5 21.49 14.5 21.49 12C21.49 9.5 15.6 5.5 12 5.5ZM11.94 16C11.1489 16 10.3755 15.7654 9.71772 15.3259C9.05992 14.8864 8.54723 14.2616 8.24448 13.5307C7.94173 12.7998 7.86252 11.9956 8.01686 11.2196C8.1712 10.4437 8.55216 9.73098 9.11157 9.17157C9.67098 8.61216 10.3837 8.2312 11.1596 8.07686C11.9356 7.92252 12.7398 8.00173 13.4707 8.30448C14.2016 8.60723 14.8264 9.11992 15.2659 9.77772C15.7054 10.4355 15.94 11.2089 15.94 12C15.94 13.0609 15.5186 14.0783 14.7684 14.8284C14.0183 15.5786 13.0009 16 11.94 16Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14.5C13.3807 14.5 14.5 13.3807 14.5 12C14.5 10.6193 13.3807 9.5 12 9.5C10.6193 9.5 9.5 10.6193 9.5 12C9.5 13.3807 10.6193 14.5 12 14.5Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9539_35731"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 12.99,
    fill: "white",
    transform: "translate(2.5 5.5)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVisibility);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "visibility.1020747fc42b4563ecbb8aab9ad4e8f8.svg";